/**
 * "Tools & execution" — MCP section (ADR-0074).
 * Reconciled from tools-list/tools-call handlers (risk markers, scope filtering,
 * record-intent default vs Channel B act-as-user) and BYOMCP.
 */
import type { DocPageContent } from '../types';

export const MCP_TOOLS_PAGE: DocPageContent = {
  slug: 'mcp/tools',
  titleKey: 'docs.mcp.tools.title',
  descriptionKey: 'docs.mcp.tools.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.mcp.tools.lead' },

    { kind: 'heading', level: 2, id: 'exposed', textKey: 'docs.mcp.tools.exposed.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.tools.exposed.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.mcp.tools.marker.stepup',
        'docs.mcp.tools.marker.destructive',
        'docs.mcp.tools.marker.live',
        'docs.mcp.tools.marker.docs',
      ],
    },

    // The exposure ladder was undocumented, and it is visible: a workspace that
    // crosses the threshold sees its tool list in Claude or Cursor change shape
    // with no explanation anywhere. Thresholds are deliberately described as
    // "a few dozen" rather than pinned to a number — the number is tuned, and a
    // doc that names it goes stale silently the next time it moves.
    { kind: 'heading', level: 2, id: 'large-catalogs', textKey: 'docs.mcp.tools.ladder.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.tools.ladder.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.mcp.tools.ladder.direct.term',
          descKey: 'docs.mcp.tools.ladder.direct.desc',
        },
        {
          termKey: 'docs.mcp.tools.ladder.search.term',
          descKey: 'docs.mcp.tools.ladder.search.desc',
        },
        {
          termKey: 'docs.mcp.tools.ladder.dynamic.term',
          descKey: 'docs.mcp.tools.ladder.dynamic.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.mcp.tools.ladder.note.title',
      textKey: 'docs.mcp.tools.ladder.note.body',
    },

    { kind: 'heading', level: 2, id: 'execution', textKey: 'docs.mcp.tools.execution.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.tools.execution.body' },
    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.mcp.tools.execution.note.title',
      textKey: 'docs.mcp.tools.execution.note.body',
    },

    { kind: 'heading', level: 2, id: 'byomcp', textKey: 'docs.mcp.tools.byomcp.heading' },
    { kind: 'paragraph', textKey: 'docs.mcp.tools.byomcp.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.mcp.tools.next.confirmation.title',
          textKey: 'docs.mcp.tools.next.confirmation.text',
          to: { docSlug: 'confirmation' },
        },
        {
          titleKey: 'docs.mcp.tools.next.reference.title',
          textKey: 'docs.mcp.tools.next.reference.text',
          to: { docSlug: 'mcp/reference' },
        },
      ],
    },
  ],
};
